<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.501 20.9232V5.83566C27.501 4.33566 26.276 3.22316 24.7885 3.34816H24.7135C22.0885 3.57316 18.101 4.91066 15.876 6.31066L15.6635 6.44816C15.301 6.67316 14.701 6.67316 14.3385 6.44816L14.026 6.26066C11.801 4.87316 7.82598 3.54816 5.20098 3.33566C3.71348 3.21066 2.50098 4.33566 2.50098 5.82316V20.9232C2.50098 22.1232 3.47598 23.2482 4.67598 23.3982L5.03848 23.4482C7.75098 23.8107 11.9385 25.1857 14.3385 26.4982L14.3885 26.5232C14.726 26.7107 15.2635 26.7107 15.5885 26.5232C17.9885 25.1982 22.1885 23.8107 24.9135 23.4482L25.326 23.3982C26.526 23.2482 27.501 22.1232 27.501 20.9232Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 6.86328V25.6133" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.68652 10.6133H6.87402" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.624 14.3633H6.87402" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
